(ns app.front.view.group.admin.import.contractor-registration
  (:require [app.domain.business.model :as business-model]
            [app.domain.contractor-registration.model :as cr-model]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::selectable-cr-statuses
  :<- [::import-session-common/root-config]
  (fn [root-config _]
    (when (-> root-config :group.config/target #{:permit-type/CR})
      [:contractor-registration.state/active
       :contractor-registration.state/revoked ;; Revocation details won't be filled in
       :contractor-registration.state/expired])))

(rf/reg-sub ::selectable-trades
  :<- [::import-session-common/root-config]
  (fn [root-config _]
    (let [category-config (->> root-config
                               :entity/_parent
                               (remove cr-model/renewal-group-config?)
                               first)]
      (->> category-config
           :entity/_parent
           (filter #(= (:entity/type %) :entity.type/group-config))))))

(defmethod import-session-common/entity-href :import-session.type/contractor-registration
  [_ entity]
  (case (:entity/type entity)
    :entity.type/contractor-registration
    (href/href :view/contractor-registration {:group-id (-> entity :domain/authority-group :group/id)
                                              :cr-id    (-> entity :contractor-registration/id)})
    ;; In the error/warning table we might also refer to business entities
    :entity.type/business
    (href/href :view/business {:business-id (-> entity :db/id)})
    nil))


(defmethod import-session-common/mapping-settings :data-import.mapping/cr-status [props]
  [(import-session-common/string-to-value-mapping-settings :data-import.mapping/cr-status
                                                           ::selectable-cr-statuses
                                                           identity
                                                           identity)
   props])

(defmethod import-session-common/mapping-settings :data-import.mapping/cr-trades [props]
  [(import-session-common/string-to-value-mapping-settings :data-import.mapping/cr-trades
                                                           ::selectable-trades
                                                           :db/id
                                                           (fn [trade lang]
                                                             (-> trade :group.config/names (i18n-model/get-text lang))))
   props])

(defmethod import-session-common/entities-cols :import-session.type/contractor-registration [_]
  [[:contractor-registration/registrant
    (fn [cr]
      (let [lang (<sub [:language])]
        (-> cr
            :contractor-registration/registrant
            (business-model/format-name lang))))]
   [:data-import.mapping/cr-trades
    (fn [cr]
      (let [lang (<sub [:language])]
        (->> cr
             cr-model/contractor-registration-trades
             (map (comp #(i18n-model/get-text % lang)
                        :group.config/names
                        :registered-trade/work-type))
             (str/join ", "))))]
   [:contractor-registration/valid-from
    (import-session-common/get-time-fn :contractor-registration/valid-from)]
   [:contractor-registration/valid-to
    (import-session-common/get-time-fn :contractor-registration/valid-to)]])
